import React, { memo } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = {
	root: {
		width: 133,
		height: 133,
		borderRadius: 20,
		margin: [['.85em', 20]],
		overflow: 'hidden',
		display: 'flex',
		justifyContent: 'center',
	},
	image: {
		height: '100%',
	},
}

// eslint-disable-next-line import/prefer-default-export
export const BrandsSliderItem = withStyles(styles, { name: 'MuiBrandsSliderItem' })(memo(({
	classes, brandName, brandLogo,
}) => (
	<section
		className={classes.root}
	>
		<LazyLoadImage
			src={brandLogo.src}
			className={classes.image}
			alt={brandName}
		/>
	</section>
)))
